/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

jQuery(document).ready(function($) {
  var h = $(".announcement").height();

  if($("#shopify-section-header .header--sticky").length > 0) {
    $("#shopify-section-header").css("top", h);
  }

  // Custom Code : Location detect
  $.get("https://ipinfo.io/json", function (response) {
    var country = response.country.trim().toUpperCase();

    if(country == 'US') {
      $("[href]").click(function(e) {
        var us_link = $(this).attr("data-us-link");
        if(typeof us_link !== 'undefined' && us_link !== false) {
          e.preventDefault();
    
          window.location.href = us_link;          
        }
      });
    }
    
  }, "jsonp");
});